module.exports = __webpack_public_path__ + "static/img/contant_9.9b5f412.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_4/contant_9.jpg
// module id = oXyL
// module chunks = 0